import './styles/DashboardCard.scss';

import { Add } from '@mui/icons-material';
import { Grid } from '@mui/material';

import { FunctionComponent } from 'react';

interface AddCardProps {
  onClick: () => void;
}

export const AddCard: FunctionComponent<AddCardProps> = props => {
  const Card = cardProps => (
    <Grid item className="dashboard-card" xs={12} sm={6} lg={4} onClick={props.onClick}>
      {cardProps.children}
    </Grid>
  );

  return (
    <Card>
      <Grid
        container
        className="dashboard-card__body"
        style={{
          justifyContent: 'center',
          alignItems: 'center',
          borderStyle: 'dashed',
          borderWidth: 2,
          borderRadius: 10,
          borderColor: 'gray',
          minHeight: 130
        }}
      >
        <Add fontSize={'large'} />
      </Grid>
    </Card>
  );
};
